import { useMemo } from 'react';
import {locale, LOCALE_CN} from './config';
const { en = {}, cn = {} } = locale;

export interface FormatMessageOptionType {
  id: string;
}

export default (locale: string, language: any) => {
  const formatMessage = useMemo(() => {
    const { en: outEn = {}, cn: outCN = {} } = language || {};
    const mergeEn = {
      ...en,
      ...outEn
    };
    const mergeCn = {
      ...mergeEn,
      ...cn,
      ...outCN
    };

    const message = locale === LOCALE_CN ? mergeCn : mergeEn;
    
    return  (option: FormatMessageOptionType): string => {
      const { id } = option;
      return message?.[id];
    }
  }, [locale, language]);

  return {
    formatMessage
  }
}
